import { defineMessage } from 'services/localization';

export const messages = {
    optionTFA: defineMessage('twofactor_authentication'),
    optionTFAUnavailable: defineMessage('as_you_registered_via_s_set_fa_is_not_available'),
    blockVerifyDescription: defineMessage('backup_options_can_be_u_o_the_authenticator_app'),
    buttonEdit: defineMessage('edit'),
    buttonEnable: defineMessage('enable'),
    buttonDisable: defineMessage('disable'),
};
